
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/verifactu",
      function () {
        return require("private-next-pages/legal/verifactu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/verifactu"])
      });
    }
  